export default __webpack_public_path__ + "static/media/d5794d4710b165c3cc314cae3d1852eb.f78d2497.png";